const questionPageUrl =
  '[portal]/questoes-de-concursos/questoes?has_commentaries=true&has_professor_commentaries=true';
const studyGuideUrl = '[ils]b/guia-de-estudos';

export const FREE_ACCESS_TEXT = 'Acesso liberado';
export const DAILY_LIMIT_TEXT = 'Limite diário';

export const benefits = {
  standard: [
    {
      type: 'counter',
      title: 'Questões',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'answers',
      icon: 'ballot-check-solid',
      link: questionPageUrl
    },
    {
      type: 'counter',
      title: 'Comentários de questões',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'comments',
      icon: 'graduation-cap-solid',
      link: questionPageUrl
    },
    {
      type: 'counter',
      title: 'Aulas da Apostila Digital',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'valhalla',
      icon: 'graduation-cap-solid',
      link: `${studyGuideUrl}/busca/pdf`
    },
    {
      type: 'counter',
      title: 'Gabarito de questões',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'teachers',
      icon: 'comments-solid',
      link: questionPageUrl
    },
    {
      type: 'counter',
      title: 'Videoaulas',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'lessons',
      icon: 'play-circle-solid',
      link: `${studyGuideUrl}/busca/todos`
    },
    {
      type: 'benefit',
      title: 'Estatísticas de questão',
      icon: 'chart-bar-solid',
      link: questionPageUrl
    }
  ],

  advanced: [
    {
      type: 'benefit',
      title: 'Questões',
      icon: 'ballot-check-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Comentários de questões',
      icon: 'comments-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Simulados',
      icon: 'file-invoice-solid',
      link: '[ils]simulados/banco'
    },
    {
      type: 'benefit',
      title: 'Gabarito de questões',
      icon: 'graduation-cap-solid',
      link: questionPageUrl
    },
    {
      type: 'counter',
      title: 'Aulas da Apostila Digital',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'valhalla',
      icon: 'graduation-cap-solid',
      link: `${studyGuideUrl}/busca/pdf`
    },
    {
      type: 'counter',
      title: 'Videoaulas',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'lessons',
      icon: 'play-circle-solid',
      link: `${studyGuideUrl}/busca/todos`
    }
  ],

  premium: [
    {
      type: 'benefit',
      title: 'Questões',
      icon: 'ballot-check-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Comentários de Questões',
      icon: 'comments-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Videoaulas',
      icon: 'play-circle-solid',
      link: `${studyGuideUrl}/busca/todos`
    },
    {
      type: 'benefit',
      title: 'Gabarito de Questões',
      icon: 'graduation-cap-solid',
      link: questionPageUrl
    },
    {
      type: 'counter',
      title: 'Aulas da Apostila Digital',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'valhalla',
      icon: 'graduation-cap-solid',
      link: `${studyGuideUrl}/busca/pdf`
    },
    {
      type: 'benefit',
      title: 'Raio-X da banca',
      icon: 'poll-h-solid',
      link: '[ils]raio-x/banca'
    }
  ],

  premium_plus: [
    {
      type: 'benefit',
      title: 'Questões',
      icon: 'ballot-check-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Gabarito de questões',
      icon: 'graduation-cap-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Raio-X da banca',
      icon: 'poll-h-solid',
      link: '[ils]raio-x/banca'
    },
    {
      type: 'benefit',
      title: 'Análise da Concorrência',
      icon: 'trophy-solid',
      link: '[ils]concorrencia/beta'
    },
    {
      type: 'counter',
      title: 'Aulas da Apostila Digital',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'valhalla',
      icon: 'graduation-cap-solid',
      link: `${studyGuideUrl}/busca/pdf`
    },
    {
      type: 'benefit',
      title: 'Resumão da Semana',
      icon: 'trainer',
      link: '[ils]treinador'
    }
  ],

  unlimited_qc: [
    {
      type: 'benefit',
      title: 'Questões',
      icon: 'ballot-check-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Simulados',
      icon: 'file-invoice-solid',
      link: '[ils]simulados/banco'
    },
    {
      type: 'benefit',
      title: 'Cursos Preparatórios',
      icon: 'book-solid',
      link: `${studyGuideUrl}/busca/pdf`
    },
    {
      type: 'benefit',
      title: 'Resumão da Semana',
      icon: 'trainer',
      link: '[ils]treinador'
    },
    {
      type: 'benefit',
      title: 'Raio-X de banca',
      icon: 'poll-h-solid',
      link: '[ils]raio-x/banca'
    },
    {
      type: 'benefit',
      title: 'Análise da concorrência',
      icon: 'trophy-solid',
      link: '[ils]concorrencia/beta'
    }
  ],

  unlimited_basic: [
    {
      type: 'benefit',
      title: 'Questões',
      icon: 'ballot-check-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Comentários de questões',
      icon: 'comments-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Simulados',
      icon: 'file-invoice-solid',
      link: '[ils]simulados/banco'
    },
    {
      type: 'benefit',
      title: 'Gabarito de questões',
      icon: 'graduation-cap-solid',
      link: questionPageUrl
    },
    {
      type: 'counter',
      title: 'Aulas da Apostila Digital',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'valhalla',
      icon: 'graduation-cap-solid',
      link: `${studyGuideUrl}/busca/pdf`
    },
    {
      type: 'counter',
      title: 'Videoaulas',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'lessons',
      icon: 'play-circle-solid',
      link: `${studyGuideUrl}/busca/todos`
    }
  ],

  unlimited_intermediate: [
    {
      type: 'benefit',
      title: 'Questões',
      icon: 'ballot-check-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Gabarito de questões',
      icon: 'graduation-cap-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Raio-X da banca',
      icon: 'poll-h-solid',
      link: '[ils]raio-x/banca'
    },
    {
      type: 'benefit',
      title: 'Análise da Concorrência',
      icon: 'trophy-solid',
      link: '[ils]concorrencia/beta'
    },
    {
      type: 'counter',
      title: 'Aulas da Apostila Digital',
      subtitle: DAILY_LIMIT_TEXT,
      resource: 'valhalla',
      icon: 'graduation-cap-solid',
      link: `${studyGuideUrl}/busca/pdf`
    },
    {
      type: 'benefit',
      title: 'Resumão da Semana',
      icon: 'trainer',
      link: '[ils]treinador'
    }
  ],

  unlimited_advanced: [
    {
      type: 'benefit',
      title: 'Questões',
      icon: 'ballot-check-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Simulados',
      icon: 'file-invoice-solid',
      link: '[ils]simulados/banco'
    },
    {
      type: 'benefit',
      title: 'Cursos Preparatórios',
      icon: 'book-solid',
      link: `${studyGuideUrl}/busca/pdf`
    },
    {
      type: 'benefit',
      title: 'Resumão da Semana',
      icon: 'trainer',
      link: '[ils]treinador'
    },
    {
      type: 'benefit',
      title: 'Raio-X de banca',
      icon: 'poll-h-solid',
      link: '[ils]raio-x/banca'
    },
    {
      type: 'benefit',
      title: 'Análise da concorrência',
      icon: 'trophy-solid',
      link: '[ils]concorrencia/beta'
    }
  ],

  unlimited_elite: [
    {
      type: 'benefit',
      title: 'Questões',
      icon: 'ballot-check-solid',
      link: questionPageUrl
    },
    {
      type: 'benefit',
      title: 'Simulados',
      icon: 'file-invoice-solid',
      link: '[ils]simulados/banco'
    },
    {
      type: 'benefit',
      title: 'Cursos Preparatórios',
      icon: 'book-solid',
      link: `${studyGuideUrl}/busca/pdf`
    },
    {
      type: 'benefit',
      title: 'Resumão da Semana',
      icon: 'trainer',
      link: '[ils]treinador'
    },
    {
      type: 'benefit',
      title: 'Raio-X de banca',
      icon: 'poll-h-solid',
      link: '[ils]raio-x/banca'
    },
    {
      type: 'benefit',
      title: 'Análise da concorrência',
      icon: 'trophy-solid',
      link: '[ils]concorrencia/beta'
    }
  ]
};
